import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";

const split = (n) => { const t = (n || "").trim().split(/\s+/); return t.length > 1 ? [t.slice(0, -1).join(" "), t[t.length - 1]] : [t[0] || "", ""]; };

export function CreatePersonDialog({ row, orgName, orgId, onClose, onCreated }) {
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", phone: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (row) { const [a, b] = split(row.name); setF({ first_name: a, last_name: b, email: "", phone: "" }); } }, [row]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      const body = { first_name: f.first_name.trim(), last_name: f.last_name.trim(), organization_id: orgId,
        ...(f.email.trim() && { email: f.email.trim() }), ...(f.phone.trim() && { phone: f.phone.trim() }) };
      const p = (await api.post("/admin/interview-import/create-person", body)).data;
      toast.success(`${p.first_name} ${p.last_name} (${p.human_id}) created`);
      onCreated();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  const ok = f.first_name.trim() && f.last_name.trim();
  return (
    <Dialog open={!!row} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="iv-create-dialog">
        <DialogHeader><DialogTitle>Create person for “{row?.name}”?</DialogTitle>
          <DialogDescription>Adds a new Lead in {orgName || "this district"}. No stage is set beyond Lead and no notifications are sent. Check the spelling against Outlook before you confirm.</DialogDescription></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <label className="text-xs font-semibold text-slate-600">First name<Input value={f.first_name} onChange={set("first_name")} className="mt-1" data-testid="iv-create-first" /></label>
          <label className="text-xs font-semibold text-slate-600">Last name<Input value={f.last_name} onChange={set("last_name")} className="mt-1" data-testid="iv-create-last" /></label>
          <label className="text-xs font-semibold text-slate-600">Email (optional)<Input value={f.email} onChange={set("email")} className="mt-1" data-testid="iv-create-email" /></label>
          <label className="text-xs font-semibold text-slate-600">Phone (optional)<Input value={f.phone} onChange={set("phone")} className="mt-1" data-testid="iv-create-phone" /></label>
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose} data-testid="iv-create-cancel">Cancel</Button>
          <Button onClick={save} disabled={busy || !ok} className="bg-[#006090] hover:bg-[#004E75]" data-testid="iv-create-confirm">Create person</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
